import {
  IKeyFiguresCashflow,
  IKeyFiguresJointCost,
  IKeyFiguresReports,
  IKeyFiguresResultsModel,
  IOperatingCostKeyFiguresModel,
} from './../models/KeyFigures'

import axios, { CancelTokenSource } from 'axios'
import {
  IKeyFiguresLoan,
  IKeyFiguresAccounts,
  IKeyFiguresLiquidity,
  IKeyFiguresUnpaidInvoices,
} from '../models/KeyFigures'

export const getKeyFigureLoansById = (clientId: string, skipcache: boolean) => {
  return axios.get<IKeyFiguresLoan[]>(
    `/KeyFigures/${clientId}/loans?skipcache=${skipcache}`
  )
}

export const getKeyFigureReportsById = (clientId: string) => {
  return axios.get<IKeyFiguresReports[]>(`/KeyFigures/${clientId}/reports`)
}

export const getKeyFigureAccountsById = (
  clientId: string,
  cancelToken?: CancelTokenSource
) => {
  return axios.get<IKeyFiguresAccounts[]>(`/KeyFigures/${clientId}/accounts`, {
    cancelToken: cancelToken?.token,
  })
}

export const getKeyFigureJointCostsById = (clientId: string) => {
  return axios.get<IKeyFiguresJointCost[]>(`/KeyFigures/${clientId}/jointcost`)
}

export const getKeyFigureLiquidity = (clientId: string, periode: number) => {
  return axios.get<IKeyFiguresLiquidity>(
    `/KeyFigures/${clientId}/liquidityforperiode/${periode}`
  )
}

export const getKeyFigureUnpaidInvoicesById = (clientId: string) => {
  return axios.get<IKeyFiguresUnpaidInvoices[]>(
    `/KeyFigures/${clientId}/unpaidinvoices`
  )
}

export const getKeyFigureOperatingCostsById = (
  clientId: string,
  year: number
) => {
  return axios.get<IOperatingCostKeyFiguresModel[]>(
    `/KeyFigures/${clientId}/operatingcost/${year}`
  )
}

export const getKeyFigureResultsById = (clientId: string, year: number) => {
  return axios.get<IKeyFiguresResultsModel[]>(
    `/KeyFigures/${clientId}/results/${year}`
  )
}

export const getKeyFigureCashflow = (clientId: string) =>
  axios.get<IKeyFiguresCashflow>(`/KeyFigures/${clientId}/cashflow`)

export const getShouldShowCashflow = (clientId: string) =>
  axios.get<boolean>(`/KeyFigures/${clientId}/shouldshowcashflow`)
